import styles from "./NavBar.module.css";
export const NavBar = ({ children }) => {
  return (
    <div className={styles.NavBar} id="NavBar">
      <div className={styles.NavBarContainer}>{children}</div>
    </div>
  );
};
